import store from "@/store";
import { getFromLocalStorage } from "@/utils/localstorage";

export default async function auth({ next, to, router }) {
  store.commit("auth/clearErrors");
  const token = getFromLocalStorage("authtoken", null);

  if (!token || !store.getters["user/getCurrentUser"]) {
    return router.push({
      name: "LoginPatient",
      query: {
        returnURL: to.href,
      },
    });
  }

  return next();
}
